<template>
  <div class="projectlist-item" @click="openPost(item['.key'],item.position)" v-bind:class="{ 'prio2':(item.priority === '2'), 'prio1':(item.priority === '1'), 'greyout':(connectionGreyout(item['.key']) === false) }">
    <div class="projectlist-item-remove" @click="remove()" v-on:click.stop>
      <svgicon :icon="'delete'"  width="24" height="24" color="#334274"></svgicon>
    </div>
    <div class="projectlist-item-info">
      <h6>{{item.title}} <span>&raquo;</span></h6>
      <span><svgicon :icon="item.icon"  width="24" height="24" color="#334274"></svgicon>
      {{item.created|formatDate}}</span>
    </div>
    <div class="projectlist-item-connectors" v-bind:class="{ 'connected':connectionGreyout(item['.key']) === true }" v-if="currentPhase - 1 == phase">
      <div v-if="connectionGreyout(item['.key']) === true" v-on:click.stop @click="removeConnection">
        <svgicon :icon="'close'" width="24" height="24" color="#334274"></svgicon>
      </div>
      <div v-if="connectionGreyout(item['.key']) === false" v-on:click.stop @click="$emit('addConnection')">
        <svgicon :icon="'plus'" width="24" height="24" color="#334274"></svgicon>
      </div>
    </div>
    <div class="project-list-item-connections" v-if="phase != 1" v-on:click.stop @click="$emit('click')" v-bind:class="{ 'open': connectionsOpen }">
      <svgicon :icon="'share'" width="26" height="26" color="#334274"></svgicon>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectListItem',
  props: ['item', 'id', 'phase', 'currentPhase'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    connectionGreyout (item) {
      if (this.$parent.connected.length > 0) {
        if (this.$parent.connected.includes(item)) {
          return true
        }
        return false
      }
      return true
    },
    removeConnection () {
      var r = confirm('Sind Sie sicher, dass Sie diese Verbindung kappen möchten?')
      if (r === true) {
        this.$emit('removeConnection')
      }
    },
    openPost (key, position) {
      this.$router.push({name: 'Map', params: {post: key, position: position}})
    },
    remove () {
      var r = confirm('Sind Sie sicher, dass Sie diesen Beitrag vom Projekt entfernen möchten?')
      if (r === true) {
        this.$emit('remove')
      }
    }
  },
  computed: {
    connectionsOpen: function () {
      if (this.$parent.connected[0] === this.item['.key'] || this.$parent.connected === undefined) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
  .project-list-item-connections {

      position: absolute;
      bottom: 0;
      left: 50%;
      width: 24px;
      height: 24px;
      z-index: 600;
      margin-left: -13.5px;
      margin-bottom: -12px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
      line-height: 20px;

      svg {
        margin-left: -1.5px;
        margin-top: -1px;
      }

      &.open {
        background-color: $color-action;
        svg path {
          fill: #fff;
        }
      }

  }

  .projectlist-item-connectors {
    position: absolute;
    z-index: 100;
    top: 0;
    width: 24px;
    left: 50%;
    margin-left: -13.5px;
    margin-top: -12px;
    height: 24px;
    background: #fff;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
    border-radius: 50%;

    text-align: center;
    line-height: 22px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectListItem.vue